import type React from "react";
import { Col, Container } from "../../../../components/Theme/grid.tsx";
import type { AssetPosition } from "../../../../kubb";
import MeterTimeSeriesCharts from "../../assets/meters/MeterTimeSeriesCharts.tsx";
import AssetPositionIssuesPreview from "../AssetPositionIssuesPreview.tsx";

interface DeviceAssetPositionDashboardProps {
  assetPosition: AssetPosition;
}

export default function DeviceAssetPositionDashboard(
  props: DeviceAssetPositionDashboardProps,
): React.ReactElement {
  return (
    <Container gap={2}>
      <Col>
        <AssetPositionIssuesPreview {...props} />
      </Col>
      <Col>
        <MeterTimeSeriesCharts device={props.assetPosition} />
      </Col>
    </Container>
  );
}
